module.exports = __webpack_public_path__ + "static/2-2a7e015bedc8f30d7b558bcb7b76cfee.jpg";